import { DEFAULT_BRANDING, type BrandingConfig } from './index'
import type { Translator } from '../i18n'

// Branding copy an organization never set resolves to DEFAULT_BRANDING's
// English. These return the organization's own words when it set them, and
// the chrome language's default otherwise.

function configuredCopy(value: string | undefined, englishDefault: string, i18n: Translator): string {
  const configured = value?.trim() || ''
  if (!configured) return ''
  return configured === englishDefault && i18n.language !== 'en' ? '' : configured
}

export function brandingButtonText(branding: BrandingConfig, i18n: Translator): string {
  return configuredCopy(branding.buttonText, DEFAULT_BRANDING.buttonText, i18n) || i18n.t('bet.addToBetslip')
}

export function copyCountLabel(label: string | undefined, count: number, i18n: Translator): string {
  return configuredCopy(label, DEFAULT_BRANDING.copyCountLabel, i18n) || i18n.tCount('card.copyCount', count)
}

/** An empty header stays empty: organizations clear it to show the band without text. */
export function winningTicketHeaderText(branding: BrandingConfig, i18n: Translator): string {
  const headerText = branding.components.winningTicket.headerText
  return headerText === DEFAULT_BRANDING.components.winningTicket.headerText && i18n.language !== 'en'
    ? i18n.t('ticket.winner')
    : headerText
}
